<template>
  <div class="rt-button-group">
    <div v-if="$slots.more">
      <el-popover
        slot="more"
        ref="popover"
        trigger="hover"
        popper-class="rtElPopover"
      >
        <div
          slot="reference"
          class="rt-button-more"
        >
          <slot name="reference" />
        </div>
        <div class="rt-button-group-popper-wrapper">
          <slot name="more" />
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RtButtonSelect',
  components: {
  }
};
</script>



// WEBPACK FOOTER //
// rtButtonSelect.vue?19cfd944